// extracted by mini-css-extract-plugin
export default {"toggle-switch":"Yw3EZjt","toggle-switch__label":"_20rIg9F","toggle-switch__switch-wrapper":"X3lWcAG","toggle-switch__switch-visual":"HFtU4_8","toggle-switch__input":"jufS0y1"};